import React from 'react';
import { LockKeyholeIcon, MonitorSmartphoneIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton } from './Shared';
import { Bamboo, KanjiBackdrop, Mandala, Needle, YinYang } from './Ornaments';
const productMockupUrl = 'https://cdn.magicpatterns.com/uploads/6d7scZtSSWvGed8yXygC4i/Mockup_MTC.png';
const trustItems = [{
  icon: MonitorSmartphoneIcon,
  label: '100% PDF',
  detail: 'Computadora, tablet o celular'
}, {
  icon: ZapIcon,
  label: 'Acceso digital',
  detail: 'En el correo de tu compra'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro',
  detail: 'Con Mercado Pago'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía',
  detail: '7 días'
}];
export function Hero() {
  const reduceMotion = useReducedMotion();
  return <header className="relative isolate overflow-hidden pb-4 pt-4 sm:pt-8 md:pb-8 lg:pt-10" data-id="element-79" data-mp="3d2lb3gldnd2t">
      <KanjiBackdrop glyphs={['中', '醫', '氣', '陰', '陽']} data-id="element-80" data-mp="3825xqp13i5ku" />
      <Mandala className="pointer-events-none absolute -right-24 top-2 -z-10 h-72 w-72 opacity-[0.1] md:right-4 md:h-96 md:w-96" color="#b45309" data-id="element-81" data-mp="384s4wnk2qj2j" />
      <Mandala className="pointer-events-none absolute -bottom-28 -left-28 -z-10 h-80 w-80 opacity-[0.08] md:h-[30rem] md:w-[30rem]" color="#047857" data-id="element-82" data-mp="3o6kfvj9sie5n" />
      <Bamboo className="absolute left-[6%] top-52 hidden h-16 w-16 opacity-40 md:block" color="#047857" data-id="element-83" data-mp="39cpbapgo3b09" />
      <Needle className="absolute right-[6%] top-60 hidden h-14 w-14 opacity-40 md:block" color="#92400e" data-id="element-84" data-mp="30i17l3qqq1dk" />

      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-85" data-mp="358hm6r6art1i">
        <motion.div initial={reduceMotion ? false : {
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-86" data-mp="35au9ljutqvly">
          <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-stone-200 bg-white px-3 py-0.5 shadow-sm sm:mb-4 sm:px-4 sm:py-1.5" data-id="element-87" data-mp="2hina4btsy8ib">
            <YinYang className="h-3.5 w-3.5 sm:h-4 sm:w-4" color="#047857" data-id="element-88" data-mp="2lmv0sejtlyj6" />
            <span className="text-[10px] font-semibold tracking-[0.22em] text-stone-900 sm:text-xs" data-id="element-89" data-mp="s2tbjfzvhzn3">
              LUMEN AKASHA™
            </span>
          </div>

          <p className="hidden text-2xl text-amber-700/80 lg:block" aria-hidden="true" data-id="element-90" data-mp="ibp18tl572yl">
            中醫
          </p>
          <p className="mb-1.5 text-[11px] font-semibold tracking-[0.16em] text-emerald-700 sm:mb-3 sm:text-sm lg:mt-1 lg:text-base" data-id="element-91" data-mp="de6ost7x25lu">
            KIT MEDICINA TRADICIONAL CHINA™
          </p>
          <h1 className="mx-auto max-w-4xl text-[24px] font-semibold leading-[1.12] tracking-tight text-stone-900 sm:text-4xl md:text-5xl lg:text-[3.5rem]" data-id="element-92" data-mp="161jcj6ptcjgq">
            ¿Querés seguir profundizando en{' '}
            <span className="font-bold text-red-700" data-id="element-93" data-mp="x030yvn9ibax">Medicina Tradicional China?</span>
          </h1>
          <p className="mx-auto mt-2 max-w-3xl text-[15px] font-semibold leading-snug text-stone-900 sm:mt-4 sm:text-xl lg:text-2xl" data-id="element-94" data-mp="3lu02z1erz4zq">
            Una Biblioteca de Estudio para Llevar tu Práctica al Siguiente Nivel
          </p>

          <div className="relative mx-auto -mt-2 w-full max-w-5xl sm:mt-0" data-id="element-95" data-mp="1xb5ped03cpfl">
            <motion.img src={productMockupUrl} alt="Mockup del Kit Medicina Tradicional China: cuaderno principal, tomos de estudio y fichas" initial={reduceMotion ? false : {
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            delay: reduceMotion ? 0 : 0.12,
            ease: [0.23, 1, 0.32, 1]
          }} className="mx-auto h-auto max-h-[52svh] w-auto max-w-full object-contain drop-shadow-xl sm:max-h-[58svh] lg:max-h-[66svh]" draggable={false} decoding="async" data-id="element-96" data-mp="21bpo3l0bc13u" />
          </div>

          <div className="mt-1 flex flex-col items-center sm:mt-3" data-id="element-97" data-mp="2tyshjyq4tln8">
            <CTAButton className="w-full max-w-[22rem] px-4 py-3.5 text-sm sm:w-auto sm:max-w-none sm:px-10 md:text-lg" data-id="element-98" data-mp="unj1bfh9cymy">
              → QUIERO MI KIT MTC AHORA
            </CTAButton>
            <ul className="mt-3 grid w-full max-w-[22rem] grid-cols-2 overflow-hidden rounded-xl border border-amber-200/70 bg-white/70 text-left shadow-sm sm:max-w-3xl md:grid-cols-4" aria-label="Condiciones de compra" data-id="element-99" data-mp="4auo8pqfqxn9">
              {trustItems.map((item, index) => <li key={item.label} className={`flex items-center gap-2 px-2.5 py-2 sm:gap-2.5 sm:px-3.5 sm:py-2.5 ${index % 2 === 1 ? 'border-l border-amber-200/70' : ''} ${index > 1 ? 'border-t border-amber-200/70 md:border-t-0' : ''} ${index === 2 ? 'md:border-l' : ''}`} data-id="element-100" data-mp="e7h9hfmobqpt" data-mpi={index}>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-emerald-50 ring-1 ring-emerald-100 sm:h-8 sm:w-8" data-id="element-101" data-mp="3csqvjqtqu6a3">
                    <item.icon className="h-3.5 w-3.5 text-emerald-700 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-102" data-mp="3mpn60237d2ha" />
                  </span>
                  <span className="min-w-0 leading-tight" data-id="element-103" data-mp="2yyr9wsrprl48">
                    <span className="block text-[11px] font-semibold text-stone-900 sm:text-xs" data-id="element-104" data-mp="2u0y2jweocl2d">
                      {item.label}
                    </span>
                    <span className="block text-[10px] text-stone-500 sm:text-[11px]" data-id="element-105" data-mp="19hcgs7bgztb5">
                      {item.detail}
                    </span>
                  </span>
                </li>)}
            </ul>
            <p className="mx-auto mt-3 max-w-2xl text-[13px] leading-snug text-stone-500 sm:text-sm" data-id="element-106" data-mp="ziejofzzargj">
              Fundamentos, Zang-Fu, diagnosis, acupuntura, digitopuntura, moxibustión, ventosas, guasha, Tuina y Qigong en una biblioteca visual de estudio.
            </p>
          </div>
        </motion.div>
      </div>
    </header>;
}